import { Star, GoogleLogo, Quotes, Heart } from '@phosphor-icons/react';
import { BRAND, REVIEWER_AVATARS } from '../lib/brand';

export const Testimonials = () => {
  const testimonials = [
    {
      name: "Kenyata Hillsman",
      rating: 5,
      text: "Her energy felt SAFE & Genuine! Thank you India for helping me out!!",
      tag: "Safe & Genuine",
      icon: Heart,
    },
    {
      name: "Nat Tauer",
      rating: 5,
      text: "Incredibly accommodating, polite, and patient... she goes above and beyond for her clients!",
      tag: "Above & Beyond",
      isLocalGuide: true,
      icon: Star,
    },
    {
      name: "Felicia Bryson",
      rating: 5,
      text: "I'm glad my husband and I got the opportunity to have her officiate our wedding!",
      tag: "Officiant Services",
      icon: Heart,
    },
  ];

  return (
    <section data-testid="testimonials-section" className="py-24 bg-white relative overflow-hidden">
      <div className="absolute top-12 left-12 opacity-[0.04] pointer-events-none">
        <Quotes weight="fill" size={300} className="text-[#800000]" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center mb-16 max-w-2xl mx-auto">
          <div className="inline-flex items-center gap-3 mb-5">
            <div className="h-px w-8 bg-[#D4AF37]" />
            <GoogleLogo weight="fill" size={20} className="text-[#4285F4]" />
            <div className="h-px w-8 bg-[#D4AF37]" />
          </div>
          <h2 className="font-serif-display text-4xl sm:text-5xl font-semibold text-[#800000] mb-4">
            <span className="italic">Safe</span> · <span className="italic">Genuine</span> · <span className="italic">Trusted</span>
          </h2>
          <div className="flex items-center justify-center gap-1.5 mb-3">
            {[...Array(5)].map((_, i) => (
              <Star key={i} weight="fill" size={26} className="text-[#D4AF37]" />
            ))}
          </div>
          <p className="text-[#5C5C5C] text-base">
            5.0 rating · verified Google reviews from Nashville neighbors
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((t, index) => (
            <article
              key={index}
              data-testid={`testimonial-card-${index}`}
              className={`relative bg-[#FBF8F1] rounded-sm p-8 border border-[#E8E2D5] hover:shadow-2xl hover:-translate-y-1 transition-all duration-500 ${
                index === 1 ? 'md:-translate-y-4 border-[#D4AF37]/40 bg-gradient-to-b from-white to-[#FBF8F1]' : ''
              }`}
            >
              <div className="absolute top-0 left-8 right-8 h-0.5 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />

              <Quotes weight="fill" size={32} className="text-[#D4AF37] mb-4" />

              <p className="text-[10px] tracking-[0.3em] uppercase font-bold text-[#800000] mb-4 flex items-center gap-2">
                <t.icon weight="fill" size={12} className="text-[#D4AF37]" />
                {t.tag}
              </p>

              <p className="font-serif-display text-xl text-[#1A1A1A] leading-relaxed mb-6 italic">
                "{t.text}"
              </p>

              <div className="flex items-center gap-1 mb-5">
                {[...Array(t.rating)].map((_, i) => (
                  <Star key={i} weight="fill" size={16} className="text-[#D4AF37]" />
                ))}
              </div>

              {/* Reviewer with photo avatar */}
              <div className="flex items-center gap-3 pt-5 border-t border-[#E8E2D5]">
                <img
                  src={REVIEWER_AVATARS[t.name]}
                  alt={`${t.name} — verified Google reviewer`}
                  className="w-12 h-12 rounded-full object-cover border-2 border-[#D4AF37]/40"
                />
                <div>
                  <p className="font-semibold text-[#1A1A1A] text-sm">{t.name}</p>
                  <div className="flex items-center gap-1.5 text-xs text-[#5C5C5C]">
                    <GoogleLogo weight="fill" size={12} className="text-[#4285F4]" />
                    {t.isLocalGuide ? 'Local Guide · Verified' : 'Verified Google Review'}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-14">
          <a
            href={BRAND.googleReviewsUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="read-more-google-reviews"
            className="inline-flex items-center gap-3 bg-[#800000] text-white hover:bg-[#5C0000] transition-all px-8 py-4 rounded-sm font-semibold text-sm tracking-[0.15em] uppercase shadow-lg hover:shadow-xl"
          >
            <GoogleLogo weight="fill" size={20} />
            Read More Reviews on Google
          </a>
        </div>
      </div>
    </section>
  );
};
